import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import Workout from 'pages/Workout/components/Workout'
import React from 'react'
import { logUtil } from 'packages/src'

export default function PlanWorkoutPage (props) {
  const {
    planId,
    planSlug,
    workoutId,
    workoutSlug
  } = props.match.params

  const startWorkoutLink = interpolateRouteUtil(ROUTE_PATH.START_WORKOUT, {
    id: workoutId,
    slug: workoutSlug
  })

  const debugProps = {
    planId,
    planSlug,
    workoutId,
    workoutSlug,
    startWorkoutLink,
    ...props
  }
  logUtil('PlanWorkoutPage').debug('debugProps=', debugProps)

  return (
    <Workout
      id={workoutId}
      planId={planId}
      isRecommended={false}
      startWorkoutLink={startWorkoutLink}
      {...props}
    />
  )
}
